import React, { useState, useEffect } from 'react';
import { db, auth } from './firebase';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { adicionarXP } from './tabelaNiveis';

// =========================================================================
// IMPORTS DOS STICKERS (Aproveitando as miniaturas dos presentes de futebol)
// =========================================================================

// Grupo 1
import imgSticker90Minutos from './assets/presentes/miniaturas/gift_90_minutos.webp';
import imgStickerAnelCampeao from './assets/presentes/miniaturas/gift_anel_de_campeao.webp';
import imgStickerApito from './assets/presentes/miniaturas/gift_apito.webp';
import imgStickerBaliza from './assets/presentes/miniaturas/gift_baliza.webp';
import imgStickerBancadaVip from './assets/presentes/miniaturas/gift_bancada_vip.webp';

// Grupo 2
import imgStickerBancoSuplentes from './assets/presentes/miniaturas/gift_banco_de_suplentes.webp';
import imgStickerBandeiraClaque from './assets/presentes/miniaturas/gift_bandeira_da_claque.webp';
import imgStickerBandeirolaCanto from './assets/presentes/miniaturas/gift_bandeirola_de_canto.webp';
import imgStickerBolaOuro from './assets/presentes/miniaturas/gift_bola_de_ouro.webp';
import imgStickerBolaChamas from './assets/presentes/miniaturas/gift_bola_em_chamas.webp';

// Grupo 3
import imgStickerBotaDiamante from './assets/presentes/miniaturas/gift_bota_de_diamante.webp';
import imgStickerBrasao from './assets/presentes/miniaturas/gift_brasao.webp';
import imgStickerCachecol from './assets/presentes/miniaturas/gift_cachecol.webp';
import imgStickerCaneleiras from './assets/presentes/miniaturas/gift_caneleiras.webp';
import imgStickerCanhaoCamisolas from './assets/presentes/miniaturas/gift_canhao_de_camisolas.webp';

// Grupo 4
import imgStickerCanhaoConfetes from './assets/presentes/miniaturas/gift_canhao_de_confetes.webp';
import imgStickerCapitao from './assets/presentes/miniaturas/gift_capitao.webp';
import imgStickerCartaoAmarelo from './assets/presentes/miniaturas/gift_cartao_amarelo.webp';
import imgStickerCartaoVermelho from './assets/presentes/miniaturas/gift_cartao_vermelho.webp';
import imgStickerChapeuGuardaRedes from './assets/presentes/miniaturas/gift_chapeu_de_guarda_redes.webp';

// Grupo 5
import imgStickerChuteira from './assets/presentes/miniaturas/gift_chuteira.webp';
import imgStickerChuteirasChamas from './assets/presentes/miniaturas/gift_chuteiras_em_chamas.webp';
import imgStickerCronometro from './assets/presentes/miniaturas/gift_cronometro.webp';
import imgStickerFiscalLinha from './assets/presentes/miniaturas/gift_fiscal_de_linha.webp';
import imgStickerFitasClaque from './assets/presentes/miniaturas/gift_fitas_da_claque.webp';

// Grupo 6
import imgStickerFumoClaque from './assets/presentes/miniaturas/gift_fumo_da_claque.webp';
import imgStickerGorroAdepto from './assets/presentes/miniaturas/gift_gorro_do_adepto.webp';
import imgStickerHallEntrada from './assets/presentes/miniaturas/gift_hall_de_entrada.webp';
import imgStickerHatTrick from './assets/presentes/miniaturas/gift_hat_trick.webp';
import imgStickerHolofotes from './assets/presentes/miniaturas/gift_holofotes.webp';

// Grupo 7
import imgStickerLuvaEspuma from './assets/presentes/miniaturas/gift_luva_de_espuma.webp';
import imgStickerLuvaPlatina from './assets/presentes/miniaturas/gift_luva_de_platina.webp';
import imgStickerLuvasGuardaRedes from './assets/presentes/miniaturas/gift_luvas_de_guarda_redes.webp';
import imgStickerMedalhaCampeao from './assets/presentes/miniaturas/gift_medalha_de_campeao.webp';
import imgStickerMedalhaViceCampeao from './assets/presentes/miniaturas/gift_medalha_de_vice_campeao.webp';

// Grupo 8
import imgStickerMegafone from './assets/presentes/miniaturas/gift_megafone.webp';
import imgStickerMeias from './assets/presentes/miniaturas/gift_meias.webp';
import imgStickerMelhorTreinador from './assets/presentes/miniaturas/gift_melhor_treinador.webp';
import imgStickerMoedaAoAr from './assets/presentes/miniaturas/gift_moeda_ao_ar.webp';
import imgStickerPlacard from './assets/presentes/miniaturas/gift_placard.webp';

// Grupo 9
import imgStickerRelvado from './assets/presentes/miniaturas/gift_relvado.webp';
import imgStickerSprayBarreira from './assets/presentes/miniaturas/gift_spray_de_barreira.webp';
import imgStickerSubstituicao from './assets/presentes/miniaturas/gift_substituicao.webp';
import imgStickerTacaSuprema from './assets/presentes/miniaturas/gift_taca_suprema.webp';
import imgStickerTamborClaque from './assets/presentes/miniaturas/gift_tambor_da_claque.webp';

// Grupo 10
import imgStickerTorresEstadio from './assets/presentes/miniaturas/gift_torres_do_estadio.webp';
import imgStickerTrofeuCampeao from './assets/presentes/miniaturas/gift_trofeu_de_campeao.webp';
import imgStickerTrofeuGuardaRedes from './assets/presentes/miniaturas/gift_trofeu_de_guarda_redes.webp';
import imgStickerVitoria from './assets/presentes/miniaturas/gift_vitoria.webp';
import imgStickerVuvuzela from './assets/presentes/miniaturas/gift_vuvuzela.webp';

// IMPORTAÇÃO DOS PRESENTES REAIS
// 1. IMPORTAÇÕES (Tudo em minúsculas como na tua pasta)
// ==========================================
// LISTA MESTRE DE PRESENTES PREMIUM (50 FUTEBOL)
// ==========================================

// Bloco Novos Presentes (Futebol)
// Bloco 1 (150 Moedas)
import imgGift90Minutos from './assets/presentes/miniaturas/gift_90_minutos.webp';
import vidGift90Minutos from './assets/presentes/leves/gift_90_minutos.webm';

import imgGiftAnelCampeao from './assets/presentes/miniaturas/gift_anel_de_campeao.webp';
import vidGiftAnelCampeao from './assets/presentes/leves/gift_anel_de_campeao.webm';

import imgGiftApito from './assets/presentes/miniaturas/gift_apito.webp';
import vidGiftApito from './assets/presentes/leves/gift_apito.webm';

import imgGiftBaliza from './assets/presentes/miniaturas/gift_baliza.webp';
import vidGiftBaliza from './assets/presentes/leves/gift_baliza.webm';

import imgGiftBancadaVip from './assets/presentes/miniaturas/gift_bancada_vip.webp';
import vidGiftBancadaVip from './assets/presentes/leves/gift_bancada_vip.webm';

import imgGiftBancoSuplentes from './assets/presentes/miniaturas/gift_banco_de_suplentes.webp';
import vidGiftBancoSuplentes from './assets/presentes/leves/gift_banco_de_suplentes.webm';

import imgGiftBandeiraClaque from './assets/presentes/miniaturas/gift_bandeira_da_claque.webp';
import vidGiftBandeiraClaque from './assets/presentes/leves/gift_bandeira_da_claque.webm';

import imgGiftBandeirolaCanto from './assets/presentes/miniaturas/gift_bandeirola_de_canto.webp';
import vidGiftBandeirolaCanto from './assets/presentes/leves/gift_bandeirola_de_canto.webm';

import imgGiftBolaOuro from './assets/presentes/miniaturas/gift_bola_de_ouro.webp';
import vidGiftBolaOuro from './assets/presentes/leves/gift_bola_de_ouro.webm';

import imgGiftBolaChamas from './assets/presentes/miniaturas/gift_bola_em_chamas.webp';
import vidGiftBolaChamas from './assets/presentes/leves/gift_bola_em_chamas.webm';

// Bloco Novos Presentes - Grupo 2 (Futebol)
import imgGiftBotaDiamante from './assets/presentes/miniaturas/gift_bota_de_diamante.webp';
import vidGiftBotaDiamante from './assets/presentes/leves/gift_bota_de_diamante.webm';

import imgGiftBrasao from './assets/presentes/miniaturas/gift_brasao.webp';
import vidGiftBrasao from './assets/presentes/leves/gift_brasao.webm';

import imgGiftCachecol from './assets/presentes/miniaturas/gift_cachecol.webp';
import vidGiftCachecol from './assets/presentes/leves/gift_cachecol.webm';

import imgGiftCaneleiras from './assets/presentes/miniaturas/gift_caneleiras.webp';
import vidGiftCaneleiras from './assets/presentes/leves/gift_caneleiras.webm';

import imgGiftCanhaoCamisolas from './assets/presentes/miniaturas/gift_canhao_de_camisolas.webp';
import vidGiftCanhaoCamisolas from './assets/presentes/leves/gift_canhao_de_camisolas.webm';

import imgGiftCanhaoConfetes from './assets/presentes/miniaturas/gift_canhao_de_confetes.webp';
import vidGiftCanhaoConfetes from './assets/presentes/leves/gift_canhao_de_confetes.webm';

import imgGiftCapitao from './assets/presentes/miniaturas/gift_capitao.webp';
import vidGiftCapitao from './assets/presentes/leves/gift_capitao.webm';

import imgGiftCartaoAmarelo from './assets/presentes/miniaturas/gift_cartao_amarelo.webp';
import vidGiftCartaoAmarelo from './assets/presentes/leves/gift_cartao_amarelo.webm';

import imgGiftCartaoVermelho from './assets/presentes/miniaturas/gift_cartao_vermelho.webp';
import vidGiftCartaoVermelho from './assets/presentes/leves/gift_cartao_vermelho.webm';

import imgGiftChapeuGuardaRedes from './assets/presentes/miniaturas/gift_chapeu_de_guarda_redes.webp';
import vidGiftChapeuGuardaRedes from './assets/presentes/leves/gift_chapeu_de_guarda_redes.webm';

// Bloco Novos Presentes - Grupo 3 (Futebol)
import imgGiftChuteira from './assets/presentes/miniaturas/gift_chuteira.webp';
import vidGiftChuteira from './assets/presentes/leves/gift_chuteira.webm';

import imgGiftChuteirasChamas from './assets/presentes/miniaturas/gift_chuteiras_em_chamas.webp';
import vidGiftChuteirasChamas from './assets/presentes/leves/gift_chuteiras_em_chamas.webm';

import imgGiftCronometro from './assets/presentes/miniaturas/gift_cronometro.webp';
import vidGiftCronometro from './assets/presentes/leves/gift_cronometro.webm';

import imgGiftFiscalLinha from './assets/presentes/miniaturas/gift_fiscal_de_linha.webp';
import vidGiftFiscalLinha from './assets/presentes/leves/gift_fiscal_de_linha.webm';

import imgGiftFitasClaque from './assets/presentes/miniaturas/gift_fitas_da_claque.webp';
import vidGiftFitasClaque from './assets/presentes/leves/gift_fitas_da_claque.webm';

import imgGiftFumoClaque from './assets/presentes/miniaturas/gift_fumo_da_claque.webp';
import vidGiftFumoClaque from './assets/presentes/leves/gift_fumo_da_claque.webm';

import imgGiftGorroAdepto from './assets/presentes/miniaturas/gift_gorro_do_adepto.webp';
import vidGiftGorroAdepto from './assets/presentes/leves/gift_gorro_do_adepto.webm';

import imgGiftHallEntrada from './assets/presentes/miniaturas/gift_hall_de_entrada.webp';
import vidGiftHallEntrada from './assets/presentes/leves/gift_hall_de_entrada.webm';

import imgGiftHatTrick from './assets/presentes/miniaturas/gift_hat_trick.webp';
import vidGiftHatTrick from './assets/presentes/leves/gift_hat_trick.webm';

import imgGiftHolofotes from './assets/presentes/miniaturas/gift_holofotes.webp';
import vidGiftHolofotes from './assets/presentes/leves/gift_holofotes.webm';

// Bloco Novos Presentes - Grupo 4 (Futebol)
import imgGiftLuvaEspuma from './assets/presentes/miniaturas/gift_luva_de_espuma.webp';
import vidGiftLuvaEspuma from './assets/presentes/leves/gift_luva_de_espuma.webm';

import imgGiftLuvaPlatina from './assets/presentes/miniaturas/gift_luva_de_platina.webp';
import vidGiftLuvaPlatina from './assets/presentes/leves/gift_luva_de_platina.webm';

import imgGiftLuvasGuardaRedes from './assets/presentes/miniaturas/gift_luvas_de_guarda_redes.webp';
import vidGiftLuvasGuardaRedes from './assets/presentes/leves/gift_luvas_de_guarda_redes.webm';

import imgGiftMedalhaCampeao from './assets/presentes/miniaturas/gift_medalha_de_campeao.webp';
import vidGiftMedalhaCampeao from './assets/presentes/leves/gift_medalha_de_campeao.webm';

import imgGiftMedalhaViceCampeao from './assets/presentes/miniaturas/gift_medalha_de_vice_campeao.webp';
import vidGiftMedalhaViceCampeao from './assets/presentes/leves/gift_medalha_de_vice_campeao.webm';

import imgGiftMegafone from './assets/presentes/miniaturas/gift_megafone.webp';
import vidGiftMegafone from './assets/presentes/leves/gift_megafone.webm';

import imgGiftMeias from './assets/presentes/miniaturas/gift_meias.webp';
import vidGiftMeias from './assets/presentes/leves/gift_meias.webm';

import imgGiftMelhorTreinador from './assets/presentes/miniaturas/gift_melhor_treinador.webp';
import vidGiftMelhorTreinador from './assets/presentes/leves/gift_melhor_treinador.webm';

import imgGiftMoedaAoAr from './assets/presentes/miniaturas/gift_moeda_ao_ar.webp';
import vidGiftMoedaAoAr from './assets/presentes/leves/gift_moeda_ao_ar.webm';

import imgGiftPlacard from './assets/presentes/miniaturas/gift_placard.webp';
import vidGiftPlacard from './assets/presentes/leves/gift_placard.webm';

// Bloco Novos Presentes - Grupo 5 (Futebol - Final)
import imgGiftRelvado from './assets/presentes/miniaturas/gift_relvado.webp';
import vidGiftRelvado from './assets/presentes/leves/gift_relvado.webm';

import imgGiftSprayBarreira from './assets/presentes/miniaturas/gift_spray_de_barreira.webp';
import vidGiftSprayBarreira from './assets/presentes/leves/gift_spray_de_barreira.webm';

import imgGiftSubstituicao from './assets/presentes/miniaturas/gift_substituicao.webp';
import vidGiftSubstituicao from './assets/presentes/leves/gift_substituicao.webm';

import imgGiftTacaSuprema from './assets/presentes/miniaturas/gift_taca_suprema.webp';
import vidGiftTacaSuprema from './assets/presentes/leves/gift_taca_suprema.webm';

import imgGiftTamborClaque from './assets/presentes/miniaturas/gift_tambor_da_claque.webp';
import vidGiftTamborClaque from './assets/presentes/leves/gift_tambor_da_claque.webm';

import imgGiftTorresEstadio from './assets/presentes/miniaturas/gift_torres_do_estadio.webp';
import vidGiftTorresEstadio from './assets/presentes/leves/gift_torres_do_estadio.webm';

import imgGiftTrofeuCampeao from './assets/presentes/miniaturas/gift_trofeu_de_campeao.webp';
import vidGiftTrofeuCampeao from './assets/presentes/leves/gift_trofeu_de_campeao.webm';

import imgGiftTrofeuGuardaRedes from './assets/presentes/miniaturas/gift_trofeu_de_guarda_redes.webp';
import vidGiftTrofeuGuardaRedes from './assets/presentes/leves/gift_trofeu_de_guarda_redes.webm';

import imgGiftVitoria from './assets/presentes/miniaturas/gift_vitoria.webp';
import vidGiftVitoria from './assets/presentes/leves/gift_vitoria.webm';

import imgGiftVuvuzela from './assets/presentes/miniaturas/gift_vuvuzela.webp';
import vidGiftVuvuzela from './assets/presentes/leves/gift_vuvuzela.webm';

import fundoAudio from './assets/fundos/fundoAudio.webp';

const listaPresentes = [
  // Patamar 100 Moedas
  { id: 101, nome: '90 Minutos', preco: 100, icone: imgSticker90Minutos, video: "" },
  { id: 102, nome: 'Anel de Campeão', preco: 100, icone: imgStickerAnelCampeao, video: "" },
  { id: 103, nome: 'Apito', preco: 100, icone: imgStickerApito, video: "" },
  { id: 104, nome: 'Baliza', preco: 100, icone: imgStickerBaliza, video: "" },
  { id: 105, nome: 'Bancada VIP', preco: 100, icone: imgStickerBancadaVip, video: "" },
  { id: 106, nome: 'Banco de Suplentes', preco: 100, icone: imgStickerBancoSuplentes, video: "" },
  { id: 107, nome: 'Bandeira da Claque', preco: 100, icone: imgStickerBandeiraClaque, video: "" },
  { id: 108, nome: 'Bandeirola de Canto', preco: 100, icone: imgStickerBandeirolaCanto, video: "" },
  { id: 109, nome: 'Bola de Ouro', preco: 100, icone: imgStickerBolaOuro, video: "" },
  { id: 110, nome: 'Bola em Chamas', preco: 100, icone: imgStickerBolaChamas, video: "" },

  // Patamar 150 Moedas
  { id: 111, nome: 'Bota de Diamante', preco: 150, icone: imgStickerBotaDiamante, video: "" },
  { id: 112, nome: 'Brasão', preco: 150, icone: imgStickerBrasao, video: "" },
  { id: 113, nome: 'Cachecol', preco: 150, icone: imgStickerCachecol, video: "" },
  { id: 114, nome: 'Caneleiras', preco: 150, icone: imgStickerCaneleiras, video: "" },
  { id: 115, nome: 'Canhão de Camisolas', preco: 150, icone: imgStickerCanhaoCamisolas, video: "" },
  { id: 116, nome: 'Canhão de Confetes', preco: 150, icone: imgStickerCanhaoConfetes, video: "" },
  { id: 117, nome: 'Capitão', preco: 150, icone: imgStickerCapitao, video: "" },
  { id: 118, nome: 'Cartão Amarelo', preco: 150, icone: imgStickerCartaoAmarelo, video: "" },
  { id: 119, nome: 'Cartão Vermelho', preco: 150, icone: imgStickerCartaoVermelho, video: "" },
  { id: 120, nome: 'Chapéu de Guarda-Redes', preco: 150, icone: imgStickerChapeuGuardaRedes, video: "" },

  // Patamar 250 Moedas
  { id: 121, nome: 'Chuteira', preco: 250, icone: imgStickerChuteira, video: "" },
  { id: 122, nome: 'Chuteiras em Chamas', preco: 250, icone: imgStickerChuteirasChamas, video: "" },
  { id: 123, nome: 'Cronómetro', preco: 250, icone: imgStickerCronometro, video: "" },
  { id: 124, nome: 'Fiscal de Linha', preco: 250, icone: imgStickerFiscalLinha, video: "" },
  { id: 125, nome: 'Fitas da Claque', preco: 250, icone: imgStickerFitasClaque, video: "" },
  { id: 126, nome: 'Fumo da Claque', preco: 250, icone: imgStickerFumoClaque, video: "" },
  { id: 127, nome: 'Gorro do Adepto', preco: 250, icone: imgStickerGorroAdepto, video: "" },
  { id: 128, nome: 'Hall de Entrada', preco: 250, icone: imgStickerHallEntrada, video: "" },
  { id: 129, nome: 'Hat-Trick', preco: 250, icone: imgStickerHatTrick, video: "" },
  { id: 130, nome: 'Holofotes', preco: 250, icone: imgStickerHolofotes, video: "" },

  // Patamar 400 Moedas
  { id: 131, nome: 'Luva de Espuma', preco: 400, icone: imgStickerLuvaEspuma, video: "" },
  { id: 132, nome: 'Luva de Platina', preco: 400, icone: imgStickerLuvaPlatina, video: "" },
  { id: 133, nome: 'Luvas de Guarda-Redes', preco: 400, icone: imgStickerLuvasGuardaRedes, video: "" },
  { id: 134, nome: 'Medalha de Campeão', preco: 400, icone: imgStickerMedalhaCampeao, video: "" },
  { id: 135, nome: 'Medalha de Vice-Campeão', preco: 400, icone: imgStickerMedalhaViceCampeao, video: "" },
  { id: 136, nome: 'Megafone', preco: 400, icone: imgStickerMegafone, video: "" },
  { id: 137, nome: 'Meias', preco: 400, icone: imgStickerMeias, video: "" },
  { id: 138, nome: 'Melhor Treinador', preco: 400, icone: imgStickerMelhorTreinador, video: "" },
  { id: 139, nome: 'Moeda ao Ar', preco: 400, icone: imgStickerMoedaAoAr, video: "" },
  { id: 140, nome: 'Placard', preco: 400, icone: imgStickerPlacard, video: "" },

  // Patamar 600 Moedas
  { id: 141, nome: 'Relvado', preco: 600, icone: imgStickerRelvado, video: "" },
  { id: 142, nome: 'Spray de Barreira', preco: 600, icone: imgStickerSprayBarreira, video: "" },
  { id: 143, nome: 'Substituição', preco: 600, icone: imgStickerSubstituicao, video: "" },
  { id: 144, nome: 'Taça Suprema', preco: 600, icone: imgStickerTacaSuprema, video: "" },
  { id: 145, nome: 'Tambor da Claque', preco: 600, icone: imgStickerTamborClaque, video: "" },
  { id: 146, nome: 'Torres do Estádio', preco: 600, icone: imgStickerTorresEstadio, video: "" },
  { id: 147, nome: 'Troféu de Campeão', preco: 600, icone: imgStickerTrofeuCampeao, video: "" },
  { id: 148, nome: 'Troféu de Guarda-Redes', preco: 600, icone: imgStickerTrofeuGuardaRedes, video: "" },
  { id: 149, nome: 'Vitória', preco: 600, icone: imgStickerVitoria, video: "" },
  { id: 150, nome: 'Vuvuzela', preco: 600, icone: imgStickerVuvuzela, video: "" }
];

// 2. LISTA REAL
const PRESENTES_REAIS_LIVECAMPO = [
    // ==========================================
  // BLOCO 1: 150 MOEDAS
  // ==========================================
  { id: 1, nome: '90 Minutos', preco: 150, icone: imgGift90Minutos, video: vidGift90Minutos },
  { id: 2, nome: 'Anel de Campeão', preco: 150, icone: imgGiftAnelCampeao, video: vidGiftAnelCampeao },
  { id: 3, nome: 'Apito', preco: 150, icone: imgGiftApito, video: vidGiftApito },
  { id: 4, nome: 'Baliza', preco: 150, icone: imgGiftBaliza, video: vidGiftBaliza },
  { id: 5, nome: 'Bancada VIP', preco: 150, icone: imgGiftBancadaVip, video: vidGiftBancadaVip },

  // ==========================================
  // BLOCO 2: 300 MOEDAS
  // ==========================================
  { id: 6, nome: 'Banco de Suplentes', preco: 300, icone: imgGiftBancoSuplentes, video: vidGiftBancoSuplentes },
  { id: 7, nome: 'Bandeira da Claque', preco: 300, icone: imgGiftBandeiraClaque, video: vidGiftBandeiraClaque },
  { id: 8, nome: 'Bandeirola de Canto', preco: 300, icone: imgGiftBandeirolaCanto, video: vidGiftBandeirolaCanto },
  { id: 9, nome: 'Bola de Ouro', preco: 300, icone: imgGiftBolaOuro, video: vidGiftBolaOuro },
  { id: 10, nome: 'Bola em Chamas', preco: 300, icone: imgGiftBolaChamas, video: vidGiftBolaChamas },

    // ==========================================
  // BLOCO 3: 450 MOEDAS
  // ==========================================
  { id: 11, nome: 'Bota de Diamante', preco: 450, icone: imgGiftBotaDiamante, video: vidGiftBotaDiamante },
  { id: 12, nome: 'Brasão', preco: 450, icone: imgGiftBrasao, video: vidGiftBrasao },
  { id: 13, nome: 'Cachecol', preco: 450, icone: imgGiftCachecol, video: vidGiftCachecol },
  { id: 14, nome: 'Caneleiras', preco: 450, icone: imgGiftCaneleiras, video: vidGiftCaneleiras },
  { id: 15, nome: 'Canhão de Camisolas', preco: 450, icone: imgGiftCanhaoCamisolas, video: vidGiftCanhaoCamisolas },

  // ==========================================
  // BLOCO 4: 600 MOEDAS
  // ==========================================
  { id: 16, nome: 'Canhão de Confetes', preco: 600, icone: imgGiftCanhaoConfetes, video: vidGiftCanhaoConfetes },
  { id: 17, nome: 'Capitão', preco: 600, icone: imgGiftCapitao, video: vidGiftCapitao },
  { id: 18, nome: 'Cartão Amarelo', preco: 600, icone: imgGiftCartaoAmarelo, video: vidGiftCartaoAmarelo },
  { id: 19, nome: 'Cartão Vermelho', preco: 600, icone: imgGiftCartaoVermelho, video: vidGiftCartaoVermelho },
  { id: 20, nome: 'Chapéu de Guarda-Redes', preco: 600, icone: imgGiftChapeuGuardaRedes, video: vidGiftChapeuGuardaRedes },

    // ==========================================
  // BLOCO 5: 750 MOEDAS
  // ==========================================
  { id: 21, nome: 'Chuteira', preco: 750, icone: imgGiftChuteira, video: vidGiftChuteira },
  { id: 22, nome: 'Chuteiras em Chamas', preco: 750, icone: imgGiftChuteirasChamas, video: vidGiftChuteirasChamas },
  { id: 23, nome: 'Cronómetro', preco: 750, icone: imgGiftCronometro, video: vidGiftCronometro },
  { id: 24, nome: 'Fiscal de Linha', preco: 750, icone: imgGiftFiscalLinha, video: vidGiftFiscalLinha },
  { id: 25, nome: 'Fitas da Claque', preco: 750, icone: imgGiftFitasClaque, video: vidGiftFitasClaque },

  // ==========================================
  // BLOCO 6: 900 MOEDAS
  // ==========================================
  { id: 26, nome: 'Fumo da Claque', preco: 900, icone: imgGiftFumoClaque, video: vidGiftFumoClaque },
  { id: 27, nome: 'Gorro do Adepto', preco: 900, icone: imgGiftGorroAdepto, video: vidGiftGorroAdepto },
  { id: 28, nome: 'Hall de Entrada', preco: 900, icone: imgGiftHallEntrada, video: vidGiftHallEntrada },
  { id: 29, nome: 'Hat-Trick', preco: 900, icone: imgGiftHatTrick, video: vidGiftHatTrick },
  { id: 30, nome: 'Holofotes', preco: 900, icone: imgGiftHolofotes, video: vidGiftHolofotes },

    // ==========================================
  // BLOCO 7: 1050 MOEDAS
  // ==========================================
  { id: 31, nome: 'Luva de Espuma', preco: 1050, icone: imgGiftLuvaEspuma, video: vidGiftLuvaEspuma },
  { id: 32, nome: 'Luva de Platina', preco: 1050, icone: imgGiftLuvaPlatina, video: vidGiftLuvaPlatina },
  { id: 33, nome: 'Luvas de Guarda-Redes', preco: 1050, icone: imgGiftLuvasGuardaRedes, video: vidGiftLuvasGuardaRedes },
  { id: 34, nome: 'Medalha de Campeão', preco: 1050, icone: imgGiftMedalhaCampeao, video: vidGiftMedalhaCampeao },
  { id: 35, nome: 'Medalha de Vice-Campeão', preco: 1050, icone: imgGiftMedalhaViceCampeao, video: vidGiftMedalhaViceCampeao },

  // ==========================================
  // BLOCO 8: 1200 MOEDAS
  // ==========================================
  { id: 36, nome: 'Megafone', preco: 1200, icone: imgGiftMegafone, video: vidGiftMegafone },
  { id: 37, nome: 'Meias', preco: 1200, icone: imgGiftMeias, video: vidGiftMeias },
  { id: 38, nome: 'Melhor Treinador', preco: 1200, icone: imgGiftMelhorTreinador, video: vidGiftMelhorTreinador },
  { id: 39, nome: 'Moeda ao Ar', preco: 1200, icone: imgGiftMoedaAoAr, video: vidGiftMoedaAoAr },
  { id: 40, nome: 'Placard', preco: 1200, icone: imgGiftPlacard, video: vidGiftPlacard },

    // ==========================================
  // BLOCO 9: 1350 MOEDAS
  // ==========================================
  { id: 41, nome: 'Relvado', preco: 1350, icone: imgGiftRelvado, video: vidGiftRelvado },
  { id: 42, nome: 'Spray de Barreira', preco: 1350, icone: imgGiftSprayBarreira, video: vidGiftSprayBarreira },
  { id: 43, nome: 'Substituição', preco: 1350, icone: imgGiftSubstituicao, video: vidGiftSubstituicao },
  { id: 44, nome: 'Taça Suprema', preco: 1350, icone: imgGiftTacaSuprema, video: vidGiftTacaSuprema },
  { id: 45, nome: 'Tambor da Claque', preco: 1350, icone: imgGiftTamborClaque, video: vidGiftTamborClaque },

  // ==========================================
  // BLOCO 10: 1500 MOEDAS
  // ==========================================
  { id: 46, nome: 'Torres do Estádio', preco: 1500, icone: imgGiftTorresEstadio, video: vidGiftTorresEstadio },
  { id: 47, nome: 'Troféu de Campeão', preco: 1500, icone: imgGiftTrofeuCampeao, video: vidGiftTrofeuCampeao },
  { id: 48, nome: 'Troféu de Guarda-Redes', preco: 1500, icone: imgGiftTrofeuGuardaRedes, video: vidGiftTrofeuGuardaRedes },
  { id: 49, nome: 'Vitória', preco: 1500, icone: imgGiftVitoria, video: vidGiftVitoria },
  { id: 50, nome: 'Vuvuzela', preco: 1500, icone: imgGiftVuvuzela, video: vidGiftVuvuzela }
];

function MenuPresentes({ aoFechar, aoEnviar, postAlvo, abaInicial }) {
  // Busca o saldo diretamente do feed de forma dinâmica e segura
  const saldoAtualBolas = window.saldoBolasGlobal || 0;

  // Lógica de Sincronização Direta com o teu Feed.jsx
  const abaAtivaDoBotao = abaInicial || 'videos';

  // 🍿 LISTA DE CROMOS DESBLOQUEADOS (ESTADO GLOBAL DA CADERNETA)
  const [stickersDonoPost, setStickersDonoPost] = useState([]);

  // 🚀 PRÉ-CARREGAMENTO INTELIGENTE EM MEMÓRIA CACHE (ANTI-IMPACIENTES)
  useEffect(() => {
    if (typeof PRESENTES_REAIS_LIVECAMPO !== 'undefined' && typeof listaPresentes !== 'undefined') {
      const todasAsMiniaturas = [
        ...PRESENTES_REAIS_LIVECAMPO.map(p => p.icone),
        ...listaPresentes.map(p => p.icone)
      ];

      todasAsMiniaturas.forEach((urlImpar) => {
        if (urlImpar) {
          const imgMemoria = new Image();
          imgMemoria.src = urlImpar;
        }
      });
    }
  }, []);

  // DICIONÁRIO MULTILÍNGUE COM PORTUGUÊS EM PRIMEIRO LUGAR DESTAQUE
  const idiomaDoTelemovel = (navigator.language || navigator.userLanguage).toLowerCase().split('-');
  
  const tM = (() => {
    if (idiomaDoTelemovel.includes('pt')) {
      return { gifts: "ENVIAR PRESENTE PREMIUM 🎁", cromos: "ENVIAR CROMO COLECIONÁVEL 🍀", adquirido: "✓ Adquirido", saldoErro: "Saldo insuficiente! Carrega mais bolas. ⚽❌" };
    } else if (idiomaDoTelemovel.includes('es')) {
      return { gifts: "ENVIAR REGALO PREMIUM 🎁", cromos: "ENVIAR CROMO COLECIONABLE 🍀", adquirido: "✓ Adquirido", saldoErro: "¡Saldo insuficiente! ⚽❌" };
    } else if (idiomaDoTelemovel.includes('fr')) {
      return { gifts: "ENVOYER CADEAU PREMIUM 🎁", cromos: "ENVOYER AUTOCOLLANT 🍀", adquirido: "✓ Acquis", saldoErro: "Solde insuffisant ! ⚽❌" };
    } else {
      return { gifts: "SEND PREMIUM GIFT 🎁", cromos: "SEND COLLECTIBLE STICKER 🍀", adquirido: "✓ Owned", saldoErro: "Insufficient balance! ⚽❌" };
    }
  })();

      // 📖 LEITOR DA CADERNETA DO DONO DO POST
  useEffect(() => {
    const idDonoDoPost = postAlvo?.idCriador || postAlvo?.userId || postAlvo?.uid || (typeof postAlvo === 'string' ? postAlvo : postAlvo?.id);
    if (!idDonoDoPost || !db) return;

    try {
      const cadernetaRef = collection(db, "utilizadores", idDonoDoPost, "caderneta_stickers");
      const q = query(cadernetaRef);
      
      const unsubscribe = onSnapshot(q, (snapshot) => {
        const listaAdquiridos = [];
        snapshot.forEach((doc) => {
          if (doc.data().desbloqueado === true) {
            listaAdquiridos.push(String(doc.id));
          }
        });
        setStickersDonoPost(listaAdquiridos);
      }, (error) => {
        console.error("Erro ao escutar caderneta global:", error);
      });

      return () => unsubscribe();
    } catch (errCaderneta) {
      console.error("Erro no arranque da caderneta do feed:", errCaderneta);
    }
  }, [postAlvo]);

      const tentarEnviar = (p) => {
    // 🛑 TRANCA DE SEGURANÇA ABSOLUTA: Impede envios repetidos de cromos já adquiridos!
    const jaAdquirido = abaAtivaDoBotao === 'stickers' && (
      stickersDonoPost.includes(String(p.id)) || 
      stickersDonoPost.includes(String(Number(p.id) - 100))
    );

    if (jaAdquirido) {
      // Bloqueia silenciosamente o clique para não gastar bolas desnecessárias
      return;
    }

    if (saldoAtualBolas < p.preco) {
      alert(tM.saldoErro);
      return;
    }
    
      if (typeof aoEnviar === 'function') {
      const recursoVisual = abaAtivaDoBotao === 'videos' ? p.video : p.icone;
      aoEnviar(p.id, recursoVisual, p.preco, postAlvo, p.nome);
      
      // 🟢 FECHA O MODAL IMEDIATAMENTE APÓS O ENVIO PARA LIMPAR O ECRÃ
      if (typeof aoFechar === 'function') aoFechar();
    }

    // ==========================================================
    // ENVIAR XP AUTOMÁTICO PARA O FIREBASE DIRECTAMENTE DO FEED
    // ==========================================================
    // 1. Dá XP de Adepto a quem enviou (utilizador autenticado)
    const meuUid = auth?.currentUser?.uid;
    if (meuUid) adicionarXP(meuUid, 'adepto', p.preco);

    // 2. Dá XP de Jogador ao dono do post que recebeu as bolas
    if (Post && Post !== meuUid) adicionarXP(Post, 'jogador', p.preco);
    // ==========================================================
  };

  // Separação cirúrgica de listas de acordo com os teus arrays originais
  const listaAExibir = abaAtivaDoBotao === 'videos' ? PRESENTES_REAIS_LIVECAMPO : listaPresentes;

  return (
    <div style={{ 
      position: 'fixed', bottom: 0, left: 0, width: '100%', height: '420px',
      zIndex: 1000005, color: 'white', fontFamily: 'sans-serif',
      display: 'flex', flexDirection: 'column', boxSizing: 'border-box',
      borderTop: abaAtivaDoBotao === 'videos' ? '2px solid #FFD700' : '2px solid #39FF14',
      borderTopLeftRadius: '25px', borderTopRightRadius: '25px',
      boxShadow: '0 -10px 35px rgba(0,0,0,0.9)',
      overflow: 'hidden',
      // Imagem desportiva preenche elegantemente todo o fundo na montra premium de vídeos
      backgroundImage: abaAtivaDoBotao === 'videos' ? `url(${fundoAudio})` : 'none',
      backgroundColor: abaAtivaDoBotao === 'videos' ? 'rgba(5, 8, 5, 0.82)' : '#07090b',
      backgroundBlendMode: 'overlay', backgroundSize: 'cover', backgroundPosition: 'center'
    }}>
      
      {/* CABEÇALHO ISOLADO EM PORTUGUÊS DE ACORDO COM O TEU SMARTPHONE */}
      <div style={{ padding: '20px 20px 10px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 2 }}>
        <span style={{ fontSize: '14px', fontWeight: '900', color: abaAtivaDoBotao === 'videos' ? '#FFD700' : '#39FF14', letterSpacing: '0.5px' }}>
          {abaAtivaDoBotao === 'videos' ? tM.gifts : tM.cromos}
        </span>
        <button 
          onClick={aoFechar}
          style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: abaAtivaDoBotao === 'videos' ? '#FFD700' : '#39FF14', fontWeight: '900', fontSize: '15px', cursor: 'pointer', borderRadius: '50%', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >✕</button>
      </div>

      {/* GRELHA DO PRODUTO ATIVO */}
      <div className="presentes-grid" style={{ flex: 1, width: '100%', overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch', padding: '0 20px 20px 20px', boxSizing: 'border-box', zIndex: 2 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', width: '100%', justifyItems: 'center', boxSizing: 'border-box' }}>
          {listaAExibir.map(p => (
            <div
              key={p.id}
              onClick={() => tentarEnviar(p)}
              style={{
                backgroundColor: 'rgba(15, 18, 15, 0.95)', 
                border: abaAtivaDoBotao === 'videos' ? '1px solid rgba(255, 215, 0, 0.25)' : '1px solid rgba(57, 255, 20, 0.15)', 
                borderRadius: '14px', backdropFilter: 'blur(10px)',
                padding: '14px 6px', textAlign: 'center', cursor: 'pointer',
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContext: 'center',
                width: '100%', maxWidth: '100px', boxSizing: 'border-box',
                boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
                transition: 'transform 0.15s ease'
              }}
            >
              <img src={p.icone} alt={p.nome} loading="eager" fetchpriority="high" style={{ width: '45px', height: '45px', objectFit: 'contain', marginBottom: '6px' }} />
              <span style={{ color: 'white', fontSize: '11px', fontWeight: 'bold', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>
                {p.nome}
              </span>
              
              {abaAtivaDoBotao === 'stickers' && (
            // 🎯 Repõe exatamente a linha original do programador antigo:
stickersDonoPost.includes(String(Number(p.id) - 100))

              ) ? (
                <span style={{ color: '#39FF14', fontSize: '10px', fontWeight: '950', marginTop: '5px', textTransform: 'uppercase' }}>
                  {tM.adquirido}
                </span>
              ) : (
                <span style={{ 
                  color: abaAtivaDoBotao === 'videos' ? '#FFD700' : '#FFF', 
                  opacity: abaAtivaDoBotao === 'videos' ? 1 : 0.7, 
                  fontSize: '10px', fontWeight: '900', marginTop: '5px' 
                }}>
                  ⚽ {p.preco.toLocaleString()}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MenuPresentes;




